module.exports = __webpack_public_path__ + "assets/images/JMD2000.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMD2000.png
// module id = 1386
// module chunks = 1